import { Card, CardContent } from '@components/card';
import { Loader } from '@components/loader';
import { BaseLayout } from '@layouts/base';
import { EditBenchUserForm } from '@components/forms/staff/benchUsers/edit';
import { useGet } from '@services/staff/benchUsers/get';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Page404 } from '@pages/404';

const EditBenchUser = () => {
  const { t } = useTranslation('app');
  const { id } = useParams({ from: '/u/$localId/_staff/staff/bench-users/$id/edit' });
  const { data: benchUser, isPending: loading } = useGet(id);

  if (loading) return <Loader />;
  if (!benchUser) return <Page404 />;

  return (
    <BaseLayout isChild title={t('pages.editBenchUser.title')}>
      <Card>
        <CardContent className="p-6">
          <EditBenchUserForm user={benchUser} />
        </CardContent>
      </Card>
    </BaseLayout>
  );
};

export const Route = createFileRoute('/u/$localId/_staff/staff/bench-users/$id/edit')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['bench_users_read', 'bench_users_update'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: EditBenchUser,
});
